export default __webpack_public_path__ + "static/media/Landing.4c6c83c6.png";